import React from "react";
import { BodyBlock } from "./auth/sign-in";
import MainLayout from "../components/layout/layout";
import {
  LabelText,
  LargeHeadline,
  SuperBigHeadline,
  TextBody,
} from "../components/typography";
import { ThemeType, ThemeTypeEnum } from "../assets/utils/validation/types";
import styled from "styled-components";
import { COLORS } from "../assets/utils/enums/colors";
import { Button } from "../components/ui/button";
import { useNavigate } from "react-router-dom";
import breakpoints from "../assets/styles/breakpoint";

const NotFoundPage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <MainLayout
      className="d-flex flex-column align-items-center justify-content-center"
      theme={ThemeTypeEnum.LIGHT}
      isNotFoundPage={true}
    >
      {" "}
      <NotFoundBlock $theme={ThemeTypeEnum.LIGHT}>
        <SuperBigHeadline>404</SuperBigHeadline>
        <LargeHeadline>{"Сторінку не зайдено :("}</LargeHeadline>
        <TextBody>
          Схоже, ми не можемо знайти сторінку, яку ви шукаєте.
        </TextBody>
        <Button
          bgcolor={COLORS.blue}
          txtcolor={COLORS.secondary1}
          brcolor={"transparent"}
          width="auto"
          type="large"
          brradius="24px"
          onClick={() => navigate(-1)}
        >
          <LabelText>Повернутися назад</LabelText>
        </Button>
      </NotFoundBlock>
    </MainLayout>
  );
};

const NotFoundBlock = styled(BodyBlock)<{ $theme: ThemeType }>`
  display: flex;
  flex-direction: column;
  padding-top: 60px;

  & > * {
    text-align: center;
    color: ${({ $theme }) =>
      $theme === ThemeTypeEnum.DARK
        ? COLORS.white
        : COLORS.secondary1} !important;
  }
  ${SuperBigHeadline} {
    color: ${({ $theme }) =>
      $theme === ThemeTypeEnum.DARK ? COLORS.white : COLORS.secondary1};
  }
  ${LargeHeadline} {
    padding-bottom: 0;
  }
  ${Button} {
    filter: brightness(
      ${({ $theme }) => ($theme === ThemeTypeEnum.DARK ? "1" : "1.4")}
    );
    padding: 14px 36px;
    margin-top: 24px;
    ${LabelText} {
      text-align: center;
      color: ${({ $theme }) =>
        $theme === ThemeTypeEnum.DARK
          ? COLORS.gray
          : COLORS.secondary1} !important;
    }
  }
  ${TextBody} {
    padding-top: 8px;
    filter: brightness(1.4);
  }

  ${breakpoints.sm} {
    gap: 8px;
    ${TextBody} {
      width: 85%;
    }
  }
`;

export default NotFoundPage;
